module.exports = __webpack_public_path__ + "static/media/2.Commercial Welding Machine.af292152.jpg";